import React, { useState } from 'react'
import { Header } from '../../../../header/Header'
import { FacilitatorHeader } from '../FacilitatorHeader'
import { useDispatch, useSelector } from 'react-redux'
import { TextAreaInput } from '../../../../user/menu/how_to_lead/TextAreaInput'
import axios from 'axios'
import { zynity_api } from '../../../../../config/external-routes'
import Swal from 'sweetalert2'
import { getUserOrganizations } from '../../../../../store/user_organizations'

const toMainTraxHide = (v: unknown): 0 | 1 => (Number(v) === 1 ? 1 : 0)

export const TeamProfile = () => {
  const dispatch = useDispatch()
  const router = useSelector((state: any) => state.router)
  const organization_id = router.selected_organization_id
  const team_id = router.selected_team_id
  const user_organizations_obj = useSelector((state: any) => state.user_organizations)
  const user_organizations = user_organizations_obj.data?.data
  const organization = user_organizations.find((item: any) => item.id == organization_id)
  const team = organization.teams.find((item: any) => item.id == team_id)

  const [formData, setFormData] = useState({
    TeamName: team.TeamName ?? '',
    Suite: team.Suite ?? '',
    Purpose: team.Purpose ?? '',
    ValueCreated: team.ValueCreated ?? '',
    RecurringDeliverables: team.RecurringDeliverables ?? '',
    hide_purpose_in_main_trax: toMainTraxHide(team.hide_purpose_in_main_trax),
    hide_value_created_in_main_trax: toMainTraxHide(team.hide_value_created_in_main_trax),
    hide_recurring_deliverables_in_main_trax: toMainTraxHide(team.hide_recurring_deliverables_in_main_trax),
  })

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | { target: { name: string; value: unknown } }
  ) => {
    const target = event.target as HTMLInputElement
    const { name } = target
    const value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const submitFormTeamProfile = (event: React.FormEvent) => {
    event.preventDefault()

    const url = zynity_api.organization_team
      .replace('{organization_id}', organization_id)
      .replace('{team_id}', team_id)

    axios
      .put(`${url}/facilitator_dashboard/team_profile`, formData)
      .then((response) => {
        dispatch(getUserOrganizations())
        Swal.fire({
          icon: 'success',
          title: 'Team updated!',
          text: response.data?.message ?? response.data?.msg ?? 'Saved.',
        })
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'We have problems updating the team profile!',
        })
      })
  }

  return (
    <>
      <Header />
      <div className="container">
        <div className="row mt-2 mb-5">
          <div className="col-12 col-md-9">
            <div className="row">
              <FacilitatorHeader page_name={'Team Profile'} />
            </div>
          </div>

          <div className="col-12 col-md-9">
            <div className="card">
              <div className="card-body">
                <form id="dataFormDetails" onSubmit={submitFormTeamProfile} noValidate>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="mb-3">
                        <label htmlFor="team-profile-name" className="form-label">
                          Team Name<span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                          id="team-profile-name"
                          type="text"
                          className="form-control"
                          name="TeamName"
                          placeholder="Enter Team Name"
                          autoComplete="off"
                          required
                          value={formData.TeamName}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="mb-3">
                        <label htmlFor="team-profile-suite" className="form-label">
                          Suite
                        </label>
                        <input
                          id="team-profile-suite"
                          type="text"
                          className="form-control"
                          name="Suite"
                          autoComplete="off"
                          readOnly
                          disabled
                          value={formData.Suite ?? ''}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-2">
                        <label className="form-label">Purpose</label>
                        <TextAreaInput
                          placeholder="Purpose"
                          key_name="Purpose"
                          value={formData.Purpose}
                          setFormDatum={handleChange}
                        />
                      </div>
                      <div className="form-check mb-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="hide_purpose_in_main_trax"
                          name="hide_purpose_in_main_trax"
                          checked={formData.hide_purpose_in_main_trax === 1}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="hide_purpose_in_main_trax">
                          Hide Purpose in MainTrax™
                        </label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-2">
                        <label className="form-label">Value Created</label>
                        <TextAreaInput
                          placeholder="Value Created"
                          key_name="ValueCreated"
                          value={formData.ValueCreated}
                          setFormDatum={handleChange}
                        />
                      </div>
                      <div className="form-check mb-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="hide_value_created_in_main_trax"
                          name="hide_value_created_in_main_trax"
                          checked={formData.hide_value_created_in_main_trax === 1}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="hide_value_created_in_main_trax">
                          Hide Value Created in MainTrax™
                        </label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-2">
                        <label className="form-label">Recurring Deliverables</label>
                        <TextAreaInput
                          placeholder="Recurring Deliverables"
                          key_name="RecurringDeliverables"
                          value={formData.RecurringDeliverables}
                          setFormDatum={handleChange}
                        />
                      </div>
                      <div className="form-check mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="hide_recurring_deliverables_in_main_trax"
                          name="hide_recurring_deliverables_in_main_trax"
                          checked={formData.hide_recurring_deliverables_in_main_trax === 1}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="hide_recurring_deliverables_in_main_trax">
                          Hide Recurring Deliverables in MainTrax™
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className="card-footer bg-transparent d-flex flex-row-reverse">
                <button type="submit" form="dataFormDetails" className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
